// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

import {
  RelationshipPropertyValueData,
} from "./types";

export default {
  sourceTwinId: __t.string(),
  targetTwinId: __t.string(),
  relationshipName: __t.string(),
  get properties() {
    return __t.array(RelationshipPropertyValueData);
  },
};
